import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView, useSpring, useTransform } from 'framer-motion';
function Counter({
  value,
  suffix = ''
}: {
  value: number;
  suffix?: string;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const spring = useSpring(0, {
    duration: 2000,
    bounce: 0
  });
  const displayValue = useTransform(spring, current => Math.floor(current));
  useEffect(() => {
    if (isInView) {
      spring.set(value);
    }
  }, [isInView, value, spring]);
  return <span ref={ref} className="flex items-baseline" data-id="element-159">
      <motion.span data-id="element-160">{displayValue}</motion.span>
      {suffix}
    </span>;
}
const stats = [{
  value: 500,
  suffix: '+',
  label: 'Унікальних подій'
}, {
  value: 10,
  suffix: '+',
  label: 'Років досвіду'
}, {
  value: 15,
  suffix: '',
  label: 'Країн світу'
}, {
  value: 50,
  suffix: 'k+',
  label: 'Задоволених гостей'
}];
export function Stats() {
  return <section className="py-24 bg-surface-light border-y border-white/5" data-id="element-161">
      <div className="container mx-auto px-6 md:px-12" data-id="element-162">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 md:gap-8 text-center" data-id="element-163">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="flex flex-col items-center justify-center" data-id="element-164">
              <h4 className="text-5xl md:text-6xl lg:text-7xl font-serif text-gold mb-4" data-id="element-165">
                <Counter value={stat.value} suffix={stat.suffix} data-id="element-166" />
              </h4>
              <p className="text-ivory/60 font-sans text-sm uppercase tracking-widest" data-id="element-167">
                {stat.label}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}